export const jobVacanciesSync = () => {
    const syncButton = $('#job-vacancies-sync-button');
    const syncResultArea = $('#job-vacancies-sync-result');

    const baseUrl = syncButton.attr('data-sync-url');
    const syncUrl = baseUrl + 'SyncVacancies';
    const statusUrl = baseUrl + 'GetVacancySyncJobStatus';

    let exitLoop = false;

    syncButton.on('click', (e) => {
        e.preventDefault();
        doSyncVacancies();
    });

    function doSyncVacancies() {
        $.ajax({
            url: syncUrl,
            success: function (data) {
                syncResultArea.html(data);
            },
            complete: function () {
                (function loop() {
                    if (!exitLoop) {
                        setTimeout(() => {
                            doShowStatus();
                            loop();
                        }, 2000);
                    }
                })();
            },
        });
    }

    async function doShowStatus() {
        $.ajax({
            url: statusUrl,
            dataType: 'json',
            success: function (data) {
                if (data) {
                    if (data.CurrentStatusMessage) {
                        syncResultArea.html(data.CurrentStatusMessage);
                    } else if (!data.IsRunning) {
                        syncResultArea.html(data.LastExecutionMessage);
                        exitLoop = true;
                    } else {
                        syncResultArea.html(syncResultArea.text() + '...');
                    }
                } else {
                    syncResultArea.html('Status onbekend');
                    exitLoop = true;
                }
            },
        });
    }
};
